import { render, staticRenderFns } from "./CopTemplateEditComponent.vue?vue&type=template&id=2b74c5b2"
import script from "./CopTemplateEditComponent.vue?vue&type=script&lang=js"
export * from "./CopTemplateEditComponent.vue?vue&type=script&lang=js"
import style0 from "./CopTemplateEditComponent.vue?vue&type=style&index=0&id=2b74c5b2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports